import * as React from "react";
import { NavLink } from "react-router-dom";
import styles from "../styles/layout.module.css";

interface Props {
  collapsed: boolean;
}

const DashboardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <rect x="1" y="1" width="6.5" height="6.5" rx="1.5" fill="currentColor" />
    <rect x="10.5" y="1" width="6.5" height="6.5" rx="1.5" fill="currentColor" />
    <rect x="1" y="10.5" width="6.5" height="6.5" rx="1.5" fill="currentColor" />
    <rect x="10.5" y="10.5" width="6.5" height="6.5" rx="1.5" fill="currentColor" />
  </svg>
);

const ApprovalsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path
      d="M14 2H4C2.9 2 2 2.9 2 4V14C2 15.1 2.9 16 4 16H14C15.1 16 16 15.1 16 14V4C16 2.9 15.1 2 14 2ZM7.5 12.5L4 9L5.4 7.6L7.5 9.7L12.6 4.6L14 6L7.5 12.5Z"
      fill="currentColor"
    />
  </svg>
);

const navItems = [
  { to: "/", label: "Dashboard", icon: <DashboardIcon />, end: true },
  { to: "/approvals", label: "Approvals", icon: <ApprovalsIcon />, end: false },
];

const Sidebar = ({ collapsed }: Props) => {
  return (
    <aside
      className={`${styles.sidebar}${collapsed ? ` ${styles.collapsed}` : ""}`}
      aria-label="Main navigation"
    >
      <nav className={styles.sidebarNav}>
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `${styles.sidebarItem}${isActive ? ` ${styles.active}` : ""}`
            }
            aria-current={undefined}
            title={collapsed ? item.label : undefined}
          >
            <>
              <span className={styles.sidebarIcon}>{item.icon}</span>
              <span className={styles.sidebarLabel}>{item.label}</span>
            </>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
